import {
	trigger,
	animate,
	style,
	transition,
	state
} from '@angular/animations';


export const customAnimations = [
    trigger('slideInOut', [
      state('1', style({ height: '*', opacity: 1 })),
      state('0', style({ height: '0px', opacity: 0 })),
      transition('1 <=> 0', animate('200ms cubic-bezier(0.23, 1, 0.32, 1)'))
    ])
]

export const filterCardAnimations = [
  trigger('filterReveal', [
    transition(':enter', [
      style({ height: '0px', opacity: 0, overflow: 'hidden' }),
      animate('200ms cubic-bezier(0.23, 1, 0.32, 1)', style({ height: '*', opacity: 1 }))
    ]),
    transition(':leave', [
      style({ overflow: 'hidden' }),
      animate('150ms cubic-bezier(0.23, 1, 0.32, 1)', style({ height: '0px', opacity: 0 }))
    ])
  ])
]

export const stepChangeAnimations = [
  trigger('stepFade', [
    transition(':enter', [
      style({ opacity: 0, transform: 'translateY(8px)' }),
      animate('220ms cubic-bezier(0.23, 1, 0.32, 1)', style({ opacity: 1, transform: 'translateY(0)' }))
    ]),
    transition(':leave', [
      animate('120ms cubic-bezier(0.23, 1, 0.32, 1)', style({ opacity: 0 }))
    ])
  ])
]